import React, { useEffect, useState } from "react";
import { ShoppingBagIcon, CurrencyYenIcon, HomeIcon, CreditCardIcon } from '@heroicons/react/outline';
import { Link, useNavigate, useLocation } from "react-router-dom";


export default function Sidebar() {
  const location = useLocation();

  const [showSublist, setShowSublist] = useState(false);
  const [showProfileSublist, setShowProfileSublist] = useState(false);
  const [showFarmSublist, setShowFarmSublist] = useState(false);
  const [showFarmMilkSublist, setShowFarmMilkSublist] = useState(false);
  const [showConstructionSublist, setShowConstructionSublist] = useState(false);
  const [showAgricultureSublist, setShowAgricultureSublist] = useState(false);
  const [showFarmAnimalSublist, setShowFarmAnimalSublist] = useState(false);
  
  const navigate = useNavigate();
  const role = localStorage.getItem('userRole');
  useEffect(() => {
    if(location.pathname.startsWith('/admin/profile')){
      setShowProfileSublist(true);
      setShowFarmSublist(false);
      setShowConstructionSublist(false);
      setShowAgricultureSublist(false);
    }else if(location.pathname.startsWith('/admin/farm')){
      setShowFarmSublist(true);
      setShowProfileSublist(false);
      setShowConstructionSublist(false);
      setShowAgricultureSublist(false);
      if(location.pathname.startsWith('/admin/farm/milk')){
        setShowFarmMilkSublist(true);
        setShowFarmAnimalSublist(false);
      }else if(location.pathname.startsWith('/admin/farm/animal')){
        setShowFarmMilkSublist(false);
        setShowFarmAnimalSublist(true);
      }else{
        setShowFarmMilkSublist(false);
        setShowFarmAnimalSublist(false);
      }
    }else if(location.pathname.startsWith('/admin/construction')){
      setShowFarmSublist(false);
      setShowProfileSublist(false);
      setShowConstructionSublist(true);
      setShowAgricultureSublist(false);
    }else if(location.pathname.startsWith('/admin/agriculture')){
      setShowFarmSublist(false);
      setShowProfileSublist(false);
      setShowConstructionSublist(false);
      setShowAgricultureSublist(true);
    }else{
      setShowProfileSublist(false);
      setShowFarmSublist(false);
      setShowConstructionSublist(false);
      setShowAgricultureSublist(false);
      
    }

    
  }, [location]);

  const toggleSublist = () => {
    setShowSublist(!showSublist);
  };
  const toggleProfileSublist = () => {
   setShowProfileSublist(!showProfileSublist);
  }
  const toggleFarmSublist = () => {
    navigate('/admin/farm/dashboard');
    setShowFarmSublist(!showFarmSublist);

   }
   const toggleConstructionSublist = () => {
    navigate('/admin/construction/dashboard');
    setShowFarmSublist(!showFarmSublist);
   }

   const toggleAgricultureSublist = () => {
    navigate('/admin/agriculture/dashboard');
    setShowAgricultureSublist(!showAgricultureSublist);
   }

  const toggleFarmMilkSublist = () => {
    setShowFarmMilkSublist(!showFarmMilkSublist);
  }

  const toggleFarmAnimalSublist = () => {
    setShowFarmAnimalSublist(!showFarmAnimalSublist);
  }
  
  const closeSidebar = () => {
    setShowSublist(false);
  };



  const handleLogout = () => {
    // Clear all local storage
    localStorage.clear();

    // Redirect to login page
    navigate('/login');
  };

  return (
    <>
      <button
        data-drawer-target="sidebar-multi-level-sidebar"
        data-drawer-toggle="sidebar-multi-level-sidebar"
        aria-controls="sidebar-multi-level-sidebar"
        onClick={toggleSublist}
        type="button"
        className="inline-flex items-center p-2 mt-2 ms-3 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
      >
        <span className="sr-only">Open sidebar</span>
        <svg
          className="w-6 h-6"
          aria-hidden="true"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            clipRule="evenodd"
            fillRule="evenodd"
            d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
          ></path>
        </svg>
      </button>

      <aside
        id="sidebar-multi-level-sidebar"
        className={`fixed top-0 left-0 z-40 w-64 h-screen transition-transform ${
          showSublist ? "translate-x-0" : "-translate-x-full"
        } sm:translate-x-0`}
        aria-label="Sidebar"
      >
        <button
          type="button"
          onClick={closeSidebar}
          className={`absolute top-3 right-3 flex items-center justify-center w-8 h-8 rounded-full bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-400 hover:bg-gray-300 dark:hover:bg-gray-600 focus:outline-none ${
            showSublist && window.innerWidth <= 768 ? "block" : "hidden"
          }`}
          aria-label="Close sidebar"
        >
            <svg
          className="w-4 h-4"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
        </button>
        <div className="h-full px-3 py-4 overflow-y-auto bg-gray-50 dark:bg-gray-800">
          <ul className="space-y-2 font-medium mt-3">
          {(role == 1 ) &&<li>
              <Link
                to="/shop_dashboard"
                className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
              >
                <ShoppingBagIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Dashboard</span>
              </Link>
            </li>}
            {(role == 1 ) &&<li>
              <Link
                to="/shop_product/list"
                className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
              >
                <CreditCardIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Product</span>
              </Link>
            </li>}
            {(role == 1 ) &&<li>
              <Link
                to="/shop_purchase/list"
                className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
              >
                <ShoppingBagIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Purchase</span>
              </Link>
            </li>}
            {(role == 1 ) &&<li>
              <Link
                to="/shop_sell/list"
                className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
              >
                <CurrencyYenIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Sell</span>
              </Link>
            </li>}
            {(role == 1 ) &&<li>
              <Link
                to="/shop_dairy_product/list"
                className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
              >
                <HomeIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Dairy Product</span>
              </Link>
            </li>}
            {(role == 1 ) &&<li>
              <Link
                to="/shop_fix_cost/list"
                className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
              >
                <CreditCardIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Fix Cost</span>
              </Link>
            </li>}
            {(role == 1 ) &&<li>
              <Link
                to="/shop_staff/list"
                className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
              >
                <CreditCardIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Staff</span>
              </Link>
            </li>}
            {(role == 1 ) &&<li>
              <Link
                to="/shop_salary/list"
                className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
              >
                <CreditCardIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Salary</span>
              </Link>
            </li>}

            {(role == 2 ) &&<li>
              <Link
                to="/admin/dashboard"
                className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
              >
                <ShoppingBagIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Dashboard</span>
              </Link>
            </li>}
            {(role == 2 ) &&<li>
              <Link
                to="/admin/account/list"
                className={`flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group  ${location.pathname.startsWith('/admin/account/list') ? 'bg-gray-200 dark:bg-gray-700' : ''}`}                
              >
                <ShoppingBagIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Account</span>
              </Link>
            </li>}
            {(role == 2 ) &&<button
                type="button"
                onClick={toggleProfileSublist}
                className="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700"
                aria-controls="dropdown-example"
                data-collapse-toggle="dropdown-example"
              >
                <svg
                  className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 18 21"
                >
                  <path d="M15 12a1 1 0 0 0 .962-.726l2-7A1 1 0 0 0 17 3H3.77L3.175.745A1 1 0 0 0 2.208 0H1a1 1 0 0 0 0 2h.438l.6 2.255v.019l2 7 .746 2.986A3 3 0 1 0 9 17a2.966 2.966 0 0 0-.184-1h2.368c-.118.32-.18.659-.184 1a3 3 0 1 0 3-3H6.78l-.5-2H15Z" />
                </svg>
                <span className="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap">
                  Profile
                </span>
                <svg
                  className={`w-3 h-3 ${
                    showProfileSublist ? "transform rotate-180" : ""
                  }`}
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 10 6"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 4 4 4-4"
                  />
                </svg>
              </button>}
              <ul
                id="dropdown-example"
                className={`${showProfileSublist ? "block" : "hidden"} py-2 space-y-2 pl-4`}
              >
               {(role == 2 ) &&<li>
              <Link
                to="/admin/profile/labour"
                className={`flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group  ${location.pathname.startsWith('/admin/profile/labour') ? 'bg-gray-200 dark:bg-gray-700' : ''}`}
              >
                <ShoppingBagIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Labour</span>
              </Link>
            </li>}
            {(role == 2 ) &&<li>
              <Link
                to="/admin/profile/company"
                className={`flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group  ${location.pathname.startsWith('/admin/profile/company') ? 'bg-gray-200 dark:bg-gray-700' : ''}`}
              >
                <ShoppingBagIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Company</span>
              </Link>
            </li>}
            {(role == 2 ) &&<li>
              <Link
                to="/admin/profile/animal"
                className={`flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group  ${location.pathname.startsWith('/admin/profile/animal') ? 'bg-gray-200 dark:bg-gray-700' : ''}`}
              >
                <ShoppingBagIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Animal</span>
              </Link>
            </li>}
            {(role == 2 ) &&<li>
              <Link
                to="/admin/profile/product"
                className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
              >
                <CreditCardIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Product</span>
              </Link>
            </li>}
              </ul>
              {(role == 2 ) &&<button
                type="button"
                onClick={toggleFarmSublist}
                className="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700"
                aria-controls="dropdown-example"
                data-collapse-toggle="dropdown-example"
              >
                <svg
                  className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 18 21"
                >
                  <path d="M15 12a1 1 0 0 0 .962-.726l2-7A1 1 0 0 0 17 3H3.77L3.175.745A1 1 0 0 0 2.208 0H1a1 1 0 0 0 0 2h.438l.6 2.255v.019l2 7 .746 2.986A3 3 0 1 0 9 17a2.966 2.966 0 0 0-.184-1h2.368c-.118.32-.18.659-.184 1a3 3 0 1 0 3-3H6.78l-.5-2H15Z" />
                </svg>
                <span className="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap">
                  Farm
                </span>
                <svg
                  className={`w-3 h-3 ${
                    showFarmSublist ? "transform rotate-180" : ""
                  }`}
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 10 6"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 4 4 4-4"
                  />
                </svg>
              </button>}
              <ul
                id="dropdown-example"
                className={`${showFarmSublist ? "block" : "hidden"} py-2 space-y-2 pl-4`}
              >
               {(role == 2 ) &&<li>
              <Link
                to="/admin/farm/labour"
                className={`flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group  ${location.pathname.startsWith('/admin/farm/labour') ? 'bg-gray-200 dark:bg-gray-700' : ''}`}
              >
                <ShoppingBagIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Labour</span>
              </Link>
            </li>}
            {(role == 2 ) &&<li>
              <Link
                to="/admin/farm/fuel"
                className={`flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group  ${location.pathname.startsWith('/admin/farm/fuel') ? 'bg-gray-200 dark:bg-gray-700' : ''}`}
              >
                <ShoppingBagIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Fuel</span>
              </Link>
            </li>}
            {(role == 2 ) &&<li>
              <Link
                to="/admin/farm/medical"
                className={`flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group  ${location.pathname.startsWith('/admin/farm/medical') ? 'bg-gray-200 dark:bg-gray-700' : ''}`}
              >
                <ShoppingBagIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Medical</span>
              </Link>
            </li>}
            {(role == 2 ) &&<li>
              <Link
                to="/admin/farm/feed"
                className={`flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group  ${location.pathname.startsWith('/admin/farm/charo_dhaan') ? 'bg-gray-200 dark:bg-gray-700' : ''}`}
              >
                <ShoppingBagIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Feed</span>
              </Link>
            </li>}
            {(role == 2 ) &&<button
                type="button"
                onClick={toggleFarmAnimalSublist}
                className="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700"
                aria-controls="dropdown-example"
                data-collapse-toggle="dropdown-example"
              >
                <svg
                  className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 18 21"
                >
                  <path d="M15 12a1 1 0 0 0 .962-.726l2-7A1 1 0 0 0 17 3H3.77L3.175.745A1 1 0 0 0 2.208 0H1a1 1 0 0 0 0 2h.438l.6 2.255v.019l2 7 .746 2.986A3 3 0 1 0 9 17a2.966 2.966 0 0 0-.184-1h2.368c-.118.32-.18.659-.184 1a3 3 0 1 0 3-3H6.78l-.5-2H15Z" />
                </svg>
                <span className="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap">
                  Animal
                </span>
                <svg
                  className={`w-3 h-3 ${
                    showFarmAnimalSublist ? "transform rotate-180" : ""
                  }`}
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 10 6"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 4 4 4-4"
                  />
                </svg>
              </button>}
              <ul
                id="dropdown-example"
                className={`${showFarmAnimalSublist ? "block" : "hidden"} py-2 space-y-2 pl-4`}
              >
               {(role == 2 ) &&<li>
              <Link
                to="/admin/farm/animal/buy_sell"
                className={`flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group  ${location.pathname.startsWith('/admin/farm/animal/buy_sell') ? 'bg-gray-200 dark:bg-gray-700' : ''}`}
              >
                <ShoppingBagIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Buy/Sell</span>
              </Link>
            </li>}
            {(role == 2 ) &&<li>
              <Link
                to="/admin/farm/animal/health"
                className={`flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group  ${location.pathname.startsWith('/admin/farm/animal/health') ? 'bg-gray-200 dark:bg-gray-700' : ''}`}
              >
                <ShoppingBagIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Health</span>
              </Link>
            </li>}</ul>
            {(role == 2 ) &&<button
                type="button"
                onClick={toggleFarmMilkSublist}
                className="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700"
                aria-controls="dropdown-example"
                data-collapse-toggle="dropdown-example"
              >
                <svg
                  className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 18 21"
                >
                  <path d="M15 12a1 1 0 0 0 .962-.726l2-7A1 1 0 0 0 17 3H3.77L3.175.745A1 1 0 0 0 2.208 0H1a1 1 0 0 0 0 2h.438l.6 2.255v.019l2 7 .746 2.986A3 3 0 1 0 9 17a2.966 2.966 0 0 0-.184-1h2.368c-.118.32-.18.659-.184 1a3 3 0 1 0 3-3H6.78l-.5-2H15Z" />
                </svg>
                <span className="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap">
                  Milk
                </span>
                <svg
                  className={`w-3 h-3 ${
                    showFarmMilkSublist ? "transform rotate-180" : ""
                  }`}
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 10 6"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 4 4 4-4"
                  />
                </svg>
              </button>}
              <ul
                id="dropdown-example"
                className={`${showFarmMilkSublist ? "block" : "hidden"} py-2 space-y-2 pl-4`}
              >
               {(role == 2 ) &&<li>
              <Link
                to="/admin/farm/milk/production"
                className={`flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group  ${location.pathname.startsWith('/admin/farm/milk/production') ? 'bg-gray-200 dark:bg-gray-700' : ''}`}
              >
                <ShoppingBagIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Production</span>
              </Link>
            </li>}
            {(role == 2 ) &&<li>
              <Link
                to="/admin/farm/milk/distributor"
                className={`flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group  ${location.pathname.startsWith('/admin/farm/milk/distributor') ? 'bg-gray-200 dark:bg-gray-700' : ''}`}
              >
                <ShoppingBagIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Distributor</span>
              </Link>
            </li>}</ul>
            {(role == 2 ) &&<li>
              <Link
                to="/admin/farm/other"
                className={`flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group  ${location.pathname.startsWith('/admin/farm/other') ? 'bg-gray-200 dark:bg-gray-700' : ''}`}
              >
                <ShoppingBagIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Other</span>
              </Link>
            </li>}
              </ul>
              {(role == 2 ) &&<button
                type="button"
                onClick={toggleConstructionSublist}
                className="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700"
                aria-controls="dropdown-example"
                data-collapse-toggle="dropdown-example"
              >
                <svg
                  className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 18 21"
                >
                  <path d="M15 12a1 1 0 0 0 .962-.726l2-7A1 1 0 0 0 17 3H3.77L3.175.745A1 1 0 0 0 2.208 0H1a1 1 0 0 0 0 2h.438l.6 2.255v.019l2 7 .746 2.986A3 3 0 1 0 9 17a2.966 2.966 0 0 0-.184-1h2.368c-.118.32-.18.659-.184 1a3 3 0 1 0 3-3H6.78l-.5-2H15Z" />
                </svg>
                <span className="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap">
                  Construction
                </span>
                <svg
                  className={`w-3 h-3 ${
                    showConstructionSublist ? "transform rotate-180" : ""
                  }`}
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 10 6"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 4 4 4-4"
                  />
                </svg>
              </button>}
              <ul
                id="dropdown-example"
                className={`${showConstructionSublist ? "block" : "hidden"} py-2 space-y-2 pl-4`}
              >
               {(role == 2 ) &&<li>
              <Link
                to="/admin/construction/labour"
                className={`flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group  ${location.pathname.startsWith('/admin/construction/labour') ? 'bg-gray-200 dark:bg-gray-700' : ''}`}
              >
                <ShoppingBagIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Labour</span>
              </Link>
            </li>}
            {(role == 2 ) &&<li>
              <Link
                to="/admin/construction/contractor"
                className={`flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group  ${location.pathname.startsWith('/admin/construction/contractor') ? 'bg-gray-200 dark:bg-gray-700' : ''}`}
              >
                <ShoppingBagIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Contractor</span>
              </Link>
            </li>}
            
      
         
            {(role == 2 ) &&<li>
              <Link
                to="/admin/construction/other"
                className={`flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group  ${location.pathname.startsWith('/admin/construction/other') ? 'bg-gray-200 dark:bg-gray-700' : ''}`}
              >
                <ShoppingBagIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Other</span>
              </Link>
            </li>}
              </ul>
              {(role == 2 ) &&<button
                type="button"
                onClick={toggleAgricultureSublist}
                className="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700"
                aria-controls="dropdown-example"
                data-collapse-toggle="dropdown-example"
              >
                <svg
                  className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 18 21"
                >
                  <path d="M15 12a1 1 0 0 0 .962-.726l2-7A1 1 0 0 0 17 3H3.77L3.175.745A1 1 0 0 0 2.208 0H1a1 1 0 0 0 0 2h.438l.6 2.255v.019l2 7 .746 2.986A3 3 0 1 0 9 17a2.966 2.966 0 0 0-.184-1h2.368c-.118.32-.18.659-.184 1a3 3 0 1 0 3-3H6.78l-.5-2H15Z" />
                </svg>
                <span className="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap">
                  Agriculture
                </span>
                <svg
                  className={`w-3 h-3 ${
                    showAgricultureSublist ? "transform rotate-180" : ""
                  }`}
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 10 6"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 4 4 4-4"
                  />
                </svg>
              </button>}
              <ul
                id="dropdown-example"
                className={`${showAgricultureSublist ? "block" : "hidden"} py-2 space-y-2 pl-4`}
              >
               {(role == 2 ) &&<li>
              <Link
                to="/admin/agriculture/labour"
                className={`flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group  ${location.pathname.startsWith('/admin/agriculture/labour') ? 'bg-gray-200 dark:bg-gray-700' : ''}`}
              >
                <ShoppingBagIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Labour</span>
              </Link>
            </li>}
            {(role == 2 ) &&<li>
              <Link
                to="/admin/agriculture/feed"
                className={`flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group  ${location.pathname.startsWith('/admin/agriculture/feed') ? 'bg-gray-200 dark:bg-gray-700' : ''}`}
              >
                <ShoppingBagIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Feed</span>
              </Link>
            </li>}
            {(role == 2 ) &&<li>
              <Link
                to="/admin/agriculture/fuel"
                className={`flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group  ${location.pathname.startsWith('/admin/agriculture/fuel') ? 'bg-gray-200 dark:bg-gray-700' : ''}`}
              >
                <ShoppingBagIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Fuel</span>
              </Link>
            </li>}
      
         
            {(role == 2 ) &&<li>
              <Link
                to="/admin/agriculture/other"
                className={`flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group  ${location.pathname.startsWith('/admin/agriculture/other') ? 'bg-gray-200 dark:bg-gray-700' : ''}`}
              >
                <ShoppingBagIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Other</span>
              </Link>
            </li>}
            {(role == 2 ) &&<li>
              <Link
                to="/admin/agriculture/sell"
                className={`flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group  ${location.pathname.startsWith('/admin/agriculture/sell') ? 'bg-gray-200 dark:bg-gray-700' : ''}`}
              >
                <ShoppingBagIcon className="w-4 h-4 inline-block" />
                <span className="ms-3">Sell</span>
              </Link>
            </li>}
              </ul>
              
            
            <li>
      <button
        onClick={handleLogout}
        className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
      >
        <svg
                  className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 18 16"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M1 8h11m0 0L8 4m4 4-4 4m4-11h3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-3"
                  />
                </svg>
        <span className="ms-3">Logout</span>
      </button>
    </li>
            
          </ul>
        </div>
      </aside>

      
    </>
  );
}
